import { useSelector } from 'react-redux';
export const selectIsTaskPaneUpdateEnabled = (_state)=>{
    return true; // Making mini update enabled by default
};
export const useTaskPaneUpdateMiniEnabled = ()=>{
    return useSelector(selectIsTaskPaneUpdateEnabled);
};
